import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import * as _ from "./lodash";

function mapProps(propMap, props) {
  return _reduceInstanceProperty(_).call(_, props, function (result, value, propName) {
    if (propMap.hasOwnProperty(propName) && !!value) {
      // TODO this is a hack for event handler accidentally getting triggered
      // Really was just intended for booleans that can be bools or funcs
      result[propMap[propName]] = _.isFunction(value) && !_includesInstanceProperty(propName).call(propName, 'handle') ? value() : value;
    } else if (propMap.hasOwnProperty(propName)) {
      result[propMap[propName]] = value;
    } else {
      result[propName] = value;
    }

    return result;
  }, {});
}

export default _.curry(mapProps);
//# sourceMappingURL=map-props.js.map